<template>
  <div v-show="isShown" ref="wrapperRef" class="sticky top-16 z-navbar pointer-events-none md:hidden" :style="wrapperStyle">
    <div ref="smartBannerMobileRef" class="w-100vw min-h-21 px-5 bg-red-00 flex pointer-events-auto" :style="smartBannerStyle">
      <div class="mt-3 mr-2 pb-3 flex flex-col justify-center flex-1 gap-2">
        <span class="font-bold" :class="isSmallVersion ? 'text-base' : 'text-lg'">{{ $t('smart.banner.title') }}</span>

        <p v-if="!isSmallVersion" class="text-sm">{{ downloadPromoText }}</p>

        <a :href="unifiedLink" target="_blank" rel="noopener noreferrer">
          <etg-button class="w-fit" type="primary" :size="isSmallVersion ? 'mini' : 'small'">
            {{ $t('smart.banner.button') }}
          </etg-button>
        </a>
      </div>

      <div class="mt-3 flex flex-col items-end justify-between">
        <svg-icon name="cancel" class="w-10 h-10 p-2 -mt-2 -mb-1 -mr-2 cursor-pointer" @click="handleClose" />

        <etg-img v-show="!isSmallVersion" class="w-30 h-30" :src="smartBannerImgPath" alt="smart-banner-phone" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const hasSmartBannerClosedCookie = useHasSmartBannerClosedCookie()

const { unifiedLink } = useDownloadLinks()
const { downloadPromoText, smartBannerImgPath } = useNewUserGift()

const smartBannerStyle = computed(() =>
  isSmallVersion.value
    ? {
        backgroundSize: '84px',
        backgroundPosition: 'bottom 0 right 20px',
        backgroundImage: 'url(/images/smart-banner-gift.svg)',
        backgroundRepeat: 'no-repeat',
      }
    : {}
)

const isShown = computed(() => !hasSmartBannerClosedCookie.value)

// for scroll
const isMounted = useMounted()
const wrapperRef = ref<Nullable<HTMLElement>>(null)
const smartBannerMobileRef = ref<Nullable<HTMLElement>>(null)

const { height: wrapperHeight } = useElementSize(wrapperRef)
const { height: bannerHeight } = useElementSize(smartBannerMobileRef)

const { y } = useWindowScroll()
const isSmallVersion = computed(() => y.value !== 0)

const wrapperStyle = computed(() => {
  const height = isSmallVersion.value ? Math.max(wrapperHeight.value, bannerHeight.value) : bannerHeight.value

  return { height: isMounted.value ? `${height}px` : 'auto' }
})

function handleClose() {
  hasSmartBannerClosedCookie.value = true
}
</script>

<style lang="scss" scoped></style>
